import 'assets/styles/custom.scss'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
// // fonts
// import "assets/fonts/sf-pro-fonts/SFPRODISPLAYBOLD.OTF"
// import "assets/fonts/sf-pro-fonts/SFPRODISPLAYREGULAR.OTF"
// style
// bootstrap
import 'bootstrap/dist/css/bootstrap.min.css'
// keen
import 'assets/styles/keen/theme01/plugins.bundle.css'
import 'assets/styles/keen/theme01/style.bundle.css'
// app custom style
import 'assets/styles/app.style.scss'
import './index.css'
// react-datepicker
import 'react-datepicker/dist/react-datepicker.css'
// redux
import store from 'app/store'
import { Provider as ReduxProvider } from 'react-redux'
import { ConfigProvider } from 'antd'
import { customTheme } from 'general/utils/CustomAntTheme'
import { HostnameProvider } from 'general/context/HostnameContext'

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <ReduxProvider store={store}>
    <BrowserRouter>
      <HostnameProvider>
        <ConfigProvider theme={customTheme}>
          <App />
        </ConfigProvider>
      </HostnameProvider>
    </BrowserRouter>
  </ReduxProvider>,
)
